module.exports = __webpack_public_path__ + "img/puppy_cat.e26c201f.jpg";